import Site from 'stores/Site'

import Page from 'classes/Page'
import Video from 'components/Video'

export default class Wall extends Page {
    constructor() {
        super()
    }

    init() {
        super.init()

        this.initVideos()
    }

    initVideos() {
        const videos = Site.page.querySelectorAll('.review-video')



        videos.forEach(video => {
            new Video(video)
        })
    }

    onResize() {
        super.onResize()
    }

    onScroll() {
        super.onScroll()
    }
}